/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicTagAndGroupResponse } from '../../models/public-tag-and-group-response';

export interface ConnectorGetTagsAndGroups$Params {
  inventoryId: string;
}

export function connectorGetTagsAndGroups(http: HttpClient, rootUrl: string, params: ConnectorGetTagsAndGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicTagAndGroupResponse>> {
  const rb = new RequestBuilder(rootUrl, connectorGetTagsAndGroups.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PublicTagAndGroupResponse>;
    })
  );
}

connectorGetTagsAndGroups.PATH = '/apollon-connector/enums/tags-and-groups';
